import axiosNew from '../../../helpers/axios'

export const fetchProjectTimelogWorkload = async (payload = {}) => {
    const { start, end, projectId = [], userId } = payload

    const data = { start, end, userId }
    if (Array.isArray(projectId) && projectId.length > 0) {
        data.projectId = projectId
    }

    return axiosNew({
        url: 'support/reports/workload/project-timelog',
        method: 'POST',
        data,
    })
}

export const fetchUserTimelogWorkload = async (payload = {}) => {
    const {
        skip = 0,
        limit = 10,
        search = '',
        start,
        end,
        projectId = [],
        userId = [],
    } = payload

    const data = {
        skip,
        limit,
        search,
        start,
        end,
        userId,
    }
    if (Array.isArray(projectId) && projectId.length > 0) {
        data.projectId = projectId
    }

    return axiosNew({
        url: 'support/reports/workload/user-timelog-list',
        method: 'POST',
        data,
    })
}

export const fetchWorkloadScreenshotsList = async (payload = {}) => {
    const {
        skip = 0,
        limit = 20,
        start,
        end,
        projectId = [],
        userId,
        assigneeId = [],
    } = payload

    const data = {
        skip,
        limit,
        start: start != null ? String(start) : undefined,
        end: end != null ? String(end) : undefined,
    }

    if (userId) data.userId = userId
    if (Array.isArray(projectId) && projectId.length > 0) {
        data.projectId = projectId
    }
    if (Array.isArray(assigneeId) && assigneeId.length > 0) {
        data.assigneeId = assigneeId
    }

    return axiosNew({
        url: 'support/reports/screenshots/list',
        method: 'POST',
        data,
    })
}
